import React from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import {DashboardWrapper, Widgets} from './Dashboard.styled';
import Widget from './Widget';
import {useEyeOptions} from '../../../../forecast-app/shared/hooks/useEyeOptions';
import {buildThirdLevelNavHeader} from '../../../../forecast-app/shared/components/headers/header-bar/header_bar';
import {getEditFixedPriceButton} from './EditFixedPriceButton';

const Dashboard = ({project, company}) => {
	const widgets = {
		INVOICED_VS_WORK_DONE: 'invoiced_vs_work_done',
		AHEAD_OR_BEHIND_SCHEDULE: 'ahead_or_behind_schedule',
		FIXED_PRICE_VS_TIME_MATERIAL: 'fixed_price_vs_time_material',
		HIGHLIGHTED_NUMBERS: 'highlighted_numbers',
		PLANNED_VS_ACTUAL_REVENUE: 'planned_vs_actual_revenue',
	};
	const widgetKeyStrings = Object.entries(widgets).map(e => e[1]);

	const [eyeOptionHeaderElement, isOptionSet] = useEyeOptions(widgetKeyStrings, 'project_budget_dashboard_options-v0.1', 'project_budget.');

	const [editFixedPriceHeaderElement] = getEditFixedPriceButton(project, company);

	let rightContent = [];
	if (editFixedPriceHeaderElement) {
		rightContent.push(editFixedPriceHeaderElement);
	}
	rightContent.push(eyeOptionHeaderElement);
	return (
		<>
			<DashboardWrapper>
				{buildThirdLevelNavHeader([], rightContent, null, {parentGroup: null})}
				<Widgets>
					{isOptionSet(widgets.INVOICED_VS_WORK_DONE) ? (
						<Widget title={'Invoiced VS Work Done'}>
							<div>Project: {project.name}</div>
						</Widget>
					) : (
						''
					)}
					{isOptionSet(widgets.AHEAD_OR_BEHIND_SCHEDULE) ? (
						<Widget title={'Ahead or behind schedule'}>
							<div>Project id {project.id}</div>
						</Widget>
					) : (
						''
					)}
					{isOptionSet(widgets.FIXED_PRICE_VS_TIME_MATERIAL) ? (
						<Widget title={'Actual fixed price VS Time & Material'}>
							<div>Fixed price: 12.000, T&M: 32.000</div>
						</Widget>
					) : (
						''
					)}
					{isOptionSet(widgets.HIGHLIGHTED_NUMBERS) ? (
						<Widget title={'Highlighted numbers'}>
							<div>72, 14, 22</div>
						</Widget>
					) : (
						''
					)}
					{isOptionSet(widgets.PLANNED_VS_ACTUAL_REVENUE) ? (
						<Widget title={'Planned VS Actual Revenue'}>
							<div>somewidgetcontents</div>
						</Widget>
					) : (
						''
					)}
				</Widgets>
			</DashboardWrapper>
		</>
	);
};
export default createFragmentContainer(Dashboard, {
	project: graphql`
		fragment Dashboard_project on ProjectType {
			id

			# used in EditFixedPrice:
			budgetType
			budget
			forecastBillablePriceScopeBased
			defaultPeriodBudgetType
			rateCard {
				currency
			}
		}
	`,
	company: graphql`
		fragment Dashboard_company on Company {
			id
			currency # used in EditFixedPrice
		}
	`,
});
